import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import "./course.sass";
import DOMPurify from "dompurify";

import planet01 from "../../assets/images/course/planet01.png";
import planet02 from "../../assets/images/course/planet02.png";
import planet03 from "../../assets/images/course/planet03.png";
import pic011 from "../../assets/images/course/pic01-1.png";
import pic012 from "../../assets/images/course/pic01-2.png";
import pic013 from "../../assets/images/course/pic01-3.png";
import pic021 from "../../assets/images/course/pic02-1.png";
// import picZh021 from "../../assets/images/course/pic_zh02-1.png";
// import picCn021 from "../../assets/images/course/pic_cn02-1.png";
// import picEn021 from "../../assets/images/course/pic_en02-1.png";
// import picJp021 from "../../assets/images/course/pic_jp02-1.png";
import pic022 from "../../assets/images/course/pic02-2.png";
import pic023 from "../../assets/images/course/pic02-3.png";
import pic031 from "../../assets/images/course/pic03-1.png";
import pic034 from "../../assets/images/course/pic03-2.png";
import pic035 from "../../assets/images/course/pic03-3.png";
import bear from "../../assets/images/course/bear.png";

import usePage from "../../hooks/usePage";
import Card from "./Card/Card";

export default function Course() {
  const { t } = useTranslation();
  const [tab, setTab] = useState("intro");
  const location = useLocation();

  usePage({ title: t("course.title") });

  const queryParams = new URLSearchParams(location.search);
  const classIndex = queryParams.get("class"); // 假設查詢參數名稱為 'class'

  const tabData = [
    {
      id: "intro",
      cardPic: [pic011, pic012, pic013],
      color: "bu",
    },
    {
      id: "workshop",
      cardPic: [pic021, pic022, pic023],
      color: "rd",
    },
    {
      id: "class",
      cardPic: [pic031, pic034, pic035],
      color: "og",
    },
  ];

  const [ballmove, setBallmove] = useState(0);
  useEffect(() => {
    const windowScroll = () => {
      setBallmove(((window.scrollY * 1.285) / 1920) * -100);
    };
    window.addEventListener("scroll", windowScroll);

    return () => {
      window.removeEventListener("scroll", windowScroll);
    };
  }, []);

  useEffect(() => {
    if (classIndex && tabData[classIndex]) {
      setTab(tabData[classIndex].id);
    }
  }, [classIndex]);

  return (
    <article className="course">
      <div className="course-bg">
        <div className="bg">
          <div className="bg-space">
            <div
              className="bg-ball01"
              style={{
                transform: `translateY(${ballmove}vh) translateZ(2vw)`,
              }}
            ></div>
            <div
              className="bg-ball02"
              style={{
                transform: `translateY(${ballmove}vh) translateZ(-20vw)`,
              }}
            ></div>
            <div
              className="bg-planet01"
              style={{
                transform: `translateY(${ballmove}vh) translateZ(-10vw)`,
              }}
            >
              <img src={planet01} alt="" />
            </div>
            <div
              className="bg-planet02"
              style={{
                transform: `translateY(${ballmove}vh) translateZ(-10vw)`,
              }}
            >
              <img src={planet02} alt="" />
            </div>
            <div
              className="bg-planet03"
              style={{
                transform: `translateY(${ballmove}vh) translateZ(-10vw)`,
              }}
            >
              <img src={planet03} alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className="course-wrap">
        <section className="course-board">
          <div className="board">
            <div className="board-head">
              <div className="board-text">
                <div className="board-title">{t("course.name")}</div>
                <div className="board-desc">{t("course.title")}</div>
              </div>
            </div>
            <div className="board-content">
              <div
                className="board-text"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(t("course.desc")),
                }}
              ></div>
            </div>
          </div>
        </section>
        <section className="course-tab">
          <div className="tab">
            <div className="tab-nav">
              {t("course.tab", {
                returnObjects: true,
              }).map((tabItem, index) => {
                return (
                  <button
                    className={tab === tabData[index].id ? "active" : ""}
                    onClick={() => {
                      setTab(tabData[index].id);
                    }}
                    key={tabData[index].id}
                  >
                    <span>{tabItem.title}</span>
                  </button>
                );
              })}
            </div>
            {t("course.tab", {
              returnObjects: true,
            }).map((tabItem, i) => {
              return (
                <div
                  className={`tab-panel${
                    tab === tabData[i].id ? " active" : ""
                  }`}
                  key={tabData[i].id}
                >
                  <div className="tab-content">
                    <div className="list">
                      {tabItem.card.map((card, j) => {
                        return (
                          <div className="list-item" key={j}>
                            <Card
                              pic={tabData[i].cardPic[j]}
                              title={card.title}
                              text={card.text}
                              btnColor={tabData[i].color}
                              btnText={card.btnText}
                              link={card.link}
                              reverse={j % 2 !== 0}
                            ></Card>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </div>
      <div className="course-float">
        <Link className="float" to="/myBear">
          <div className="float-title">
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(t("course.bear")),
              }}
            ></div>
          </div>
          <div className="float-pic">
            <img src={bear} alt="" />
            <div className="float-shine"></div>
          </div>
        </Link>
      </div>
    </article>
  );
}
